module.exports = __webpack_public_path__ + "static/media/enspng.cf961ea9.png";